module.exports = __webpack_public_path__ + "static/media/ni.d0aee04c.svg";